export function Notifications() {
  return (
    <div>
      <h2 style={{ marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>Notifications</h2>
      <div style={{ background: "white", padding: "24px", borderRadius: "8px", border: "1px solid #e5e7eb" }}>
        <p>This is the notifications page content. View and manage your notifications here.</p>
        <div style={{ marginTop: "20px" }}>
          <h3 style={{ marginBottom: "10px" }}>Recent Notifications</h3>
          <div style={{ padding: "12px", background: "#f9fafb", borderRadius: "6px", marginBottom: "8px" }}>
            <p>
              <strong>Meeting Reminder:</strong> You have a meeting in 30 minutes
            </p>
          </div>
          <div style={{ padding: "12px", background: "#f9fafb", borderRadius: "6px", marginBottom: "8px" }}>
            <p>
              <strong>New Message:</strong> You have 3 unread messages
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
